import React from 'react';
import { NAV_LOGO_WIDTH, SIDE_NAV_WIDTH } from 'constants/ThemeConstant';
import { APP_NAME } from 'configs/AppConfig';
import { connect } from 'react-redux';
import utils from 'utils';
import { Grid } from 'antd';
import { Link } from 'react-router-dom';

const { useBreakpoint } = Grid;

const getLogoWidthGutter = (props, isMobile) => {
  if (isMobile && !props.mobileLogo) {
    return 0;
  }
  return `${SIDE_NAV_WIDTH}px`;
};

const getLogoDisplay = (isMobile, mobileLogo) => {
  if (isMobile && !mobileLogo) {
    return 'd-none';
  } else {
    return 'logo';
  }
};

export const Logo = (props) => {
  const isMobile = !utils.getBreakPoint(useBreakpoint()).includes('lg');
  return (
    <div
      className={getLogoDisplay(isMobile, props.mobileLogo)}
      style={{ width: `${getLogoWidthGutter(props, isMobile)}` }}
    >
      <Link to="/">
        <img style={{ width: `${NAV_LOGO_WIDTH}px` }} src="/img/logo.png" alt={`${APP_NAME} logo`} />
      </Link>
    </div>
  );
};

const mapStateToProps = ({ theme }) => {
  const { navCollapsed } = theme;
  return { navCollapsed };
};

export default connect(mapStateToProps)(Logo);
